export const NAVBAR_CLICK_EVENT = 'Click on Navbar';
export const NOTIFICATIONS_QUERY_INTERVAL = 60000;
export const DROPDOWN_MENU_ITEM_CLICK_EVENT = 'Unified Dropdown Menu Item Click';
export const DROPDOWN_MENU_DISPLAY_EVENT = 'Unified Dropdown Menu Display';
export const DROPDOWN_MENU_BALANCE_CLICK_EVENT = 'Unified Dropdown Menu Balance Click';
export const DROPDOWN_MENU_SIGN_OUT_EVENT = 'Unified Dropdown Menu Sign Out';
export const DROPDOWN_MENU_SIGN_IN_EVENT = 'Unified Dropdown Menu Sign In';
//# sourceMappingURL=constants.js.map